import { apiClient } from '../../client'
import { PaginatedResponse } from '../role.repository'

export interface PromoDescription {
  id: number
  tenant_id: number
  en_name: string
  ar_name: string
  status: number
  created_by: number
  created_at: string
  updated_by: number
  updated_at: string
}

export interface CreatePromoDescriptionRequest {
  en_name: string
  ar_name: string
  status?: number
}

export interface UpdatePromoDescriptionRequest {
  en_name?: string
  ar_name?: string
  status?: number
}

class PromoDescriptionsRepository {
  async getAll(
    page: number = 1,
    limit: number = 10,
    filters?: { search?: string; status?: string },
  ): Promise<PaginatedResponse<PromoDescription>> {
    const params = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    })

    if (filters?.search?.trim()) params.append('search', filters.search.trim())
    if (filters?.status?.trim()) params.append('status', filters.status.trim())

    return apiClient.get<PaginatedResponse<PromoDescription>>(
      `/client-promo-descriptions?${params.toString()}`,
    )
  }

  async getOne(id: number): Promise<PromoDescription> {
    return apiClient.get<PromoDescription>(`/client-promo-descriptions/${id}`)
  }

  async create(data: CreatePromoDescriptionRequest): Promise<PromoDescription> {
    return apiClient.post<PromoDescription>('/client-promo-descriptions', data)
  }

  async update(id: number, data: UpdatePromoDescriptionRequest): Promise<PromoDescription> {
    return apiClient.put<PromoDescription>(`/client-promo-descriptions/${id}`, data)
  }

  async remove(id: number): Promise<{ message: string }> {
    return apiClient.delete<{ message: string }>(`/client-promo-descriptions/${id}`)
  }
}

export const promoDescriptionsRepository = new PromoDescriptionsRepository()
